/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import * as default_data from '../config.js'
import { logout, setWithExpiry, updateUser, isPaid, getUser, getToken } from '../AuthService.js'
import { useSearchParams } from "react-router-dom";
import APIKeysList from '../APIKeys/APIKeysList'
import Modal from 'react-modal';
import HeaderLogged from '../Chat/HeaderLogged'
import { getBannerColor } from '../Utils/classification_helper.js';

function ModifyForm({currentColor, switchColor}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [user, setUser] = useState({});
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [custom_intro_prompt, setCustomIntroPrompt] = useState('');
  const [paid, setPaid] = useState(false);
  const [hasStripeID, sethasStripeID] = useState(false);
  const [checkoutMode, setCheckoutMode] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [triggerAPIKeysList, setTriggerAPIKeysList] = useState(0);

  var loaded_static = false;

  function updateInfo() {
    var token = getToken()

    fetch(default_data.default_user_service_url_no_cac + '/validate_token_with_full_user', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'x-access-tokens': `${token}`
     },        
     body: JSON.stringify({
     })
   })
     .then(response => {
       if (response.ok) {
         return response.json();
       }
       throw new Error('An error occurred while sending chats.');
     })
     .then(data => {
       if(data.status != 200) {
           console.log(data.response);
       }
       else {          
         setPaid(data.response.paid)
         if(data.response.stripe_customer_id != null && data.response.stripe_customer_id != '') {
            sethasStripeID(true)
         }
         else {
            sethasStripeID(false)
         }
         var user = data.response;
         setWithExpiry('user', JSON.stringify(user));
         setUser(user)         
       }
      })
      .catch(error => {
  
      });  
  }

  useEffect(() => {
    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    var user = getUser()
     if(user == false) {
      window.location = '/login';
      return;
     }
     setFirstName(user.first_name)
     setLastName(user.last_name)
     setCompany(user.company)
     setPhone(user.phone)
     setEmail(user.email)
     setCustomIntroPrompt(user.custom_intro_prompt)

     updateInfo()

          setCheckoutMode(false)
          var action = searchParams.get("action")
          if(action == 'checkout') {
            window.location = '/payment';
            return;
          }         
          else if(action == 'cancel_checkout') {
            setErrorMessage('You have cancelled your payment. Please try again. If you have any issues, please reach out us to at sales@asksage.ai');
            setSuccessMessage('')
          } 
          else if(action == 'success_checkout') {
            setErrorMessage('')
            setSuccessMessage('Congratulations! Welcome to the Ask Sage family, your subscription is now active!');
            updateInfo()

            // start a 5s timer and redirect to /dashboard
            const sleep = async (milliseconds) => {
              await new Promise(resolve => {
                  return setTimeout(resolve, milliseconds)
              });
            };
            const run_sleep = async () => {
              await sleep(5000);
              window.location.href = '/dashboard';
            }
            run_sleep();
          } 
          else if(action == 'success_update_checkout') {
            setErrorMessage('')
            setSuccessMessage('Thank you, your subscription has been updated!');
            updateInfo()

            // start a 5s timer and redirect to /dashboard
            const sleep = async (milliseconds) => {
              await new Promise(resolve => {
                  return setTimeout(resolve, milliseconds)
              });
            };
            const run_sleep = async () => {
              await sleep(5000);
              window.location.href = '/dashboard';
            }
            run_sleep();
          } 
          else if(action == 'force_password') {
            setErrorMessage('Your password has expired, you must update it before continuing.');
            setSuccessMessage('');
          } 

  });

  const handleSubmit = event => {
    event.preventDefault();
    setIsLoading(true);

    var token = getToken()
    if(token === false) {
      return;
    }

    fetch(default_data.default_user_service_url_no_cac + '/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },        
      body: JSON.stringify({
        first_name: firstName,
        last_name: lastName,
        company: company,
        phone: phone,        
        password: password,
        custom_intro_prompt: custom_intro_prompt
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while updating your account.');
      })
      .then(data => {
        if(data.status != 200) {
          throw new Error(data.response);
        }
        setIsLoading(false);
        // Clear the form and display a success message
        setErrorMessage('');

        updateUser(firstName, lastName, company, phone, custom_intro_prompt)
        setSuccessMessage("Your account has been updated!");

        const sleep = async (milliseconds) => {
          await new Promise(resolve => {
              return setTimeout(resolve, milliseconds)
          });
        };
        const run_sleep = async () => {
          await sleep(2000);
          if(password != '' && password.length > 0) {
            logout()
          }
          else {
            window.location.href = '/dashboard';
          }        
        }
        run_sleep();
      })
      .catch(error => {
        setIsLoading(false);
        setErrorMessage(error.message);
      });
  };

  Modal.setAppElement('#root');

  return (
    <div>
    { 
      <div className={`header-message ${getBannerColor(false)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'UNCLASSIFIED' 
        }
      </div>            
    }
    { 
      ((paid != true && default_data.default_customer_tenant !== true) || (user && user.plan_type && user.plan_type === 'trial')) ? 
      <div className='header_nonmember'>
        <a href="/payment">{default_data.default_subscribe_banner_text}</a>
      </div>            
      : 
      ''
    }
    <HeaderLogged  />
    <div className="reg-page-mode">
    <Container>
      <Row className="justify-content-center reg-page-mode-header">
        <Col xs="12" md="12" lg="12">
          <h1>Account</h1>
        </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-content">
        <Col xs="12" md="8" lg="8">
          {(checkoutMode == true) ? 
          <div>
            <h2 style={{margin: '30px 20px', textAlign: 'center'}}>Redirecting you to Stripe for your subscription...</h2>
          </div>
          :
          <div>
            <Form onSubmit={handleSubmit}>
              {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
              {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
              <FormGroup>
                <Label for="firstName">First Name</Label>
                <Input type="text" value={firstName} onChange={event => setFirstName(event.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label for="lastName">Last Name</Label>
                <Input type="text" value={lastName} onChange={event => setLastName(event.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label for="company">Company</Label>
                <Input type="text" value={company} onChange={event => setCompany(event.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input type="text" value={email} readOnly />
              </FormGroup>
              <FormGroup>
                <Label for="phone">Phone</Label>
                <Input type="tel" value={phone} onChange={event => setPhone(event.target.value)} />
              </FormGroup>
              { 
                (paid == true) ? 
              <FormGroup>
                <Label for="custom_intro_prompt">Describe yourself (maximum 800 characters) - used in every prompt to let Ask Sage know more about you and your context.</Label>
                <textarea className="custom-intro-prompt-textarea" value={custom_intro_prompt} onChange={event => setCustomIntroPrompt(event.target.value)}></textarea>
              </FormGroup> : ''
              }
              { user.plan_type !== 'unknown' ?              
                <FormGroup>
                  <Label for="plan_type">Ask Sage Subscription</Label>
                  <Input type="text" value={user.plan_type} disabled /> <a href="/payment">Manage your subscription</a>
                </FormGroup> : '' }
              <FormGroup>
                <Label for="password">Password (leave empty if unchanged)</Label>
                <Input type="password" value={password} onChange={event => setPassword(event.target.value)} />
              </FormGroup>
              <br />
              {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
              {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
              <Button className="btn-with-bg" type="submit" disabled={isLoading}>
                {isLoading ? 'Loading...' : 'Submit'}
              </Button>
              <br /><br />
              { 
                default_data.default_customer_tenant === true ? '' : 
                (paid != true && hasStripeID === false) ? 
                <div><Button className="btn-with-bg" block href="/payment">Subscribe now to get access to our API, and get 500,000 query tokens/mo with 500,000 training tokens/mo for only $30/mo!</Button><br /></div> 
                : 
                (paid != true && hasStripeID === true) ? 
                <div>
                  <Button block className="btn-with-bg" href="/payment">Re-subscribe to Ask Sage (become a paid user)</Button>
                <br />
                </div>
                :
                
                (paid == true && hasStripeID !== false && user.plan_type !== 'free' && user.plan_type !== 'unknown' && user.plan_type !== 'enterprise') ?
                <div>
                  <Button block className="btn-with-bg" href="/payment" target="_blank" rel="noopener noreferrer">Manage your subscription (tokens, upgrade plan etc.)</Button>
                <br />
                </div>
                :
                ''
              }
            </Form>

            <a className="btn-with-bg" href="/dashboard">
                Back
            </a>
            <br /><br />
           </div>
          }
          </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-footer">
        <Col xs="12" md="12" lg="12">
          Copyright &copy; {default_data.default_copywrite_year} Ask Sage, Inc.
        </Col>
      </Row>
      </Container>
      <APIKeysList setTriggerAPIKeysList={setTriggerAPIKeysList} triggerAPIKeysList={triggerAPIKeysList} />
    </div>
    </div>
  );
}

export default ModifyForm;
